<template>
  <div class="modal-mask" v-show="showModal">
    <div class="modal-wrapper" @click.stop>
      <div class="modal-inr modal-type01" v-if="isPc">
        <div class="modal-template">
          <div class="modal-template-img">
            <p class="is-portrait">
              <img alt :src="templateActive.thumbnailUrl" />
            </p>
          </div>
          <div class="modal-template-info">
            <div class="close-modal" @click="closeModal">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="times-circle"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                class="icon-close svg-inline--fa fa-times-circle fa-w-16"
              >
                <path
                  fill="currentColor"
                  d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
                  class
                />
              </svg>
            </div>
            <div class="info-template">
              <label
                class="template-status"
                v-if="
                  templateActive.templateStatus ==
                    $t('front_end.a010.private_type')
                "
                >{{ $t('front_end.a010.private_type') }}</label
              >
              <p class="name-template">{{ templateActive.templateId }}</p>
              <p class="description-template">{{ templateActive.type }}</p>
            </div>
            <button
              class="btn btn-plane btn-select-sheet"
              @click="roadToTemplateEditor()"
            >
              <div class="btn-txt">
                <span class="btn-txt-ttl">{{
                  $t('front_end.a010.btn.use_template')
                }}</span>
              </div>
            </button>
          </div>
        </div>
        <div
          class="modal-btn-prev slider-btn"
          @click="changeTemplateSelect(false)"
          :class="isSliderFirst ? 'disabled' : ''"
        ></div>
        <div
          class="modal-btn-next slider-btn"
          @click="changeTemplateSelect(true)"
          :class="isSliderEnd ? 'disabled' : ''"
        ></div>
      </div>
      <!-- mobile -->
      <div
        :class="{
          islandscape: rotateType === `landscape`,
          'modal-infor-landscape': rotateType === `landscape`,
        }"
        class="modal-infor col-md-10 col-12 col-xl-8 p-0 m-auto row"
        ref="contentModal"
        v-else
      >
        <div
          class="col-md-1 w-100 h-100 swiper-button"
          :class="{ 'swiper-button-landscape': rotateType === 'landscape' }"
        >
          <div
            class="modal-btn-prev slider-btn"
            @click="changeTemplateSelect(false)"
            :class="isSliderFirst ? 'disabled' : ''"
          ></div>
        </div>
        <div
          class="col-md-4 col-12 slide-swiper h-100"
          :class="{ 'slide-swiper-landscape': rotateType === `landscape` }"
        >
          <div
            class="header-modal-mobile"
            ref="headerMobile"
            :class="{
              'header-modal-mobile-landscape': rotateType === `landscape`,
            }"
          >
            <div class="close-modal-mobile" @click="closeModal">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="times-circle"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                class="icon-close svg-inline--fa fa-times-circle fa-w-16"
              >
                <path
                  fill="currentColor"
                  d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
                  class
                />
              </svg>
            </div>
            <div class="info-template-mobile">
              <label
                class="template-status"
                v-if="
                  templateActive.templateStatus ==
                    $t('front_end.a010.private_type')
                "
                >{{ $t('front_end.a010.private_type') }}</label
              >
              <p class="category-template">{{ templateActive.templateId }}</p>
              <p class="name-template">{{ templateActive.type }}</p>
            </div>
          </div>
          <swiper
            :options="swiperOption"
            ref="swiperThemeMobile"
            class="slider-container lazy-loading"
            :class="{
              'slider-container-landspace': rotateType === `landscape`,
            }"
            @slideChange="slideChange()"
          >
            <swiper-slide
              v-for="(image, index) in listTemplateSelect"
              :key="index"
              class="lazy-loading__item"
            >
              <img
                :class="{
                  'w-100': isIpad,
                  'mobile-mainimg-portrait': rotateType === `portrait`,
                }"
                :src="image.thumbnailUrl"
              />
            </swiper-slide>
          </swiper>
          <div
            class="pt-4 pb-4"
            :class="{ 'select-btn-landspace': rotateType === `landscape` }"
          >
            <button
              class="btn btn-plane btn-select-sheet-mobile"
              @click="roadToTemplateEditor()"
              ref="buttonMobile"
            >
              <div class="btn-txt">
                <span class="btn-txt-ttl">
                  {{ $t('front_end.a010.btn.use_template') }}</span
                >
              </div>
            </button>
          </div>
        </div>
        <div
          class="col-md-4 bg-white h-100 content-info-template"
          :class="{
            'content-info-template-landscape': rotateType === 'landscape',
          }"
        >
          <div
            class="close-modal"
            :class="{ 'close-modal-landspace': rotateType === `landscape` }"
            @click="closeModal"
          >
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="times-circle"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              class="icon-close svg-inline--fa fa-times-circle fa-w-16"
            >
              <path
                fill="currentColor"
                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
                class
              />
            </svg>
          </div>
          <div
            class="info-template"
            :class="{ 'info-template-landscape': rotateType === 'landscape' }"
          >
            <label
              class="template-status"
              v-if="
                templateActive.templateStatus ==
                  $t('front_end.a010.private_type')
              "
              >{{ $t('front_end.a010.private_type') }}</label
            >
            <p class="category-template">{{ templateActive.templateId }}</p>
            <p class="name-template">{{ templateActive.type }}</p>
          </div>
          <button
            class="btn btn-plane btn-select-sheet"
            @click="roadToTemplateEditor()"
            :class="{
              'btn-select-sheet-landscape': rotateType === 'landscape',
            }"
          >
            <div class="btn-txt">
              <span class="btn-txt-ttl">{{
                $t('front_end.a010.btn.use_template')
              }}</span>
            </div>
          </button>
        </div>
        <div
          class="col-md-1 w-100 h-100 swiper-button"
          :class="{ 'swiper-button-landscape': rotateType === 'landscape' }"
        >
          <div
            class="modal-btn-next slider-btn"
            @click="changeTemplateSelect(true)"
            :class="isSliderEnd ? 'disabled' : ''"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import deviceUtil from '../../utils/deviceUtil'
import categoryDefinitions from '@/mixins/categoryDefinitions'
import { mapGetters } from 'vuex'

const FROMA015 = 'a015'
export default {
  name: 'A015',
  data() {
    return {
      rotateType: '',
      showModal: false,
      templateActive: {},
      templateId: null,
      isSliderEnd: false,
      isSliderFirst: false,
      isPc: deviceUtil.isPc(),
      isIpad: deviceUtil.isiPad(),
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      listTemplateSelect: [],
    }
  },
  mixins: [categoryDefinitions],
  computed: {
    ...mapGetters(['shopMode', 'userData']),
  },

  created() {
    let _self = this
    if (window.innerWidth > window.innerHeight) {
      this.rotateType = 'landscape'
    } else {
      this.rotateType = 'portrait'
    }

    function doOnOrientationChange() {
      let rotateType = ''
      switch (window.orientation) {
        case -90:
        case 90:
          rotateType = 'landscape'
          _self.rotateType = rotateType
          break
        default:
          rotateType = 'portrait'
          _self.rotateType = rotateType
          break
      }
    }

    window.addEventListener('orientationchange', doOnOrientationChange)

    // Initial execution if needed
    doOnOrientationChange()

    // window.onorientationchange = function(event) {
    //   // alert("window event 1121 "+ window.orientation);
    //  let rotateType = "";
    //   if (event.target?.screen?.orientation?.angle === 0){
    //     rotateType =  "portrait";
    //     // alert("portrait");
    //   } else {
    //     //  alert("landscape");
    //     rotateType =  "landscape";
    //   }

    //   _self.rotateType = rotateType;
    // };
  },
  mounted() {
    if (this.userData.templates) {
      let _self = this
      _self.listTemplateSelect = _self.userData.templates.listTemplateSelect
      _self.templateActive = _self.userData.templates.templateActive
      let templateActive = _self.userData.templates.templateActive
      if (!_self.isPc) {
        _self.listTemplateSelect.forEach(function(item, key) {
          if (item.templateId === templateActive.templateId) {
            _self.$refs.swiperThemeMobile.$swiper.activeIndex = key
          }
        })
      }
    }
    this.showModalCSS()
  },
  methods: {
    showModalCSS() {
      this.templateId = this.templateActive.templateId
      this.showModal = true
      document.body.classList.add('modal-open')
      this.checkFirstEndSlide()
    },
    closeModal() {
      this.showModal = false
      document.body.classList.remove('modal-open')
      this.$router.push({ name: 'a010' })
    },
    changeTemplateSelect(isNext) {
      let self = this
      let index
      this.listTemplateSelect.forEach(function(item, key) {
        if (item.templateId === self.templateActive.templateId) {
          index = key
        }
      })
      if (isNext && index < this.listTemplateSelect.length - 1) {
        index += 1
      }

      if (!isNext && index > 0) {
        index -= 1
      }
      //
      this.isSliderEnd = index === this.listTemplateSelect.length - 1
      this.isSliderFirst = index === 0
      this.templateId = this.listTemplateSelect[index].templateId
      this.templateActive = this.listTemplateSelect[index]
      if (!this.isPc) {
        this.$refs.swiperThemeMobile.$swiper.activeIndex = index
      }
      this.$store.commit('userData/SET_TEMPLATES', {
        templateActive: this.templateActive,
      })
    },

    slideChange() {
      this.templateId = this.listTemplateSelect[
        this.$refs.swiperThemeMobile.$swiper.activeIndex
      ].templateId
      this.templateActive = this.templateId = this.listTemplateSelect[
        this.$refs.swiperThemeMobile.$swiper.activeIndex
      ]
      this.$store.commit('userData/SET_TEMPLATES', {
        templateActive: this.templateActive,
      })
      this.checkFirstEndSlide()
    },
    roadToTemplateEditor() {
      this.$store.commit('userData/SET_SELECTED', {
        template: this.templateActive,
      })

      //delete sessionStorage.ed
      sessionStorage.setItem('ed', '{}')
      this.clearSession()

      location.href =
        '/editor/' + this.templateActive.templateId + '?from=' + FROMA015
    },

    clearSession() {
      this.$store.dispatch('userData/clearOrderInfo')
    },

    checkFirstEndSlide() {
      this.templateId = this.templateActive.templateId
      this.isSliderEnd =
        this.listTemplateSelect[this.listTemplateSelect.length - 1]
          .templateId === this.templateId
      this.isSliderFirst =
        this.listTemplateSelect[0].templateId === this.templateId
    },
  },

  destroyed() {
    document.body.classList.remove('modal-open')
  },
}
</script>
<style
  scoped
  src="../../assets/css/confirmSelectTemplate/confirmSelectTemplate.css"
></style>
<style scoped>
.btn-select-sheet-landscape {
  display: block;
  background: #dd0017;
  padding: 10px;
  color: #ffffff;
  font-weight: bold;
  position: absolute;
  bottom: 20%;
  width: 90%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}
.swiper-button-landscape {
  display: flex;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
  flex: 0 0 8.333333%;
  max-width: 8.333333%;
}
.content-info-template-landscape {
  display: flex;
  justify-content: center;
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
}
.info-template-landscape {
  display: block;
  width: 100%;
  height: 70%;
  padding: 40px 20px;
}
.slide-swiper-landscape {
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
  background-color: #fcccd3;
  padding: 20px;
}
.header-modal-mobile-landscape,
.select-btn-landspace {
  display: none;
}
.slider-container-landspace {
  width: 100%;
  height: 100%;
  padding: 0;
}
.close-modal-landspace {
  display: block;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
.modal-infor-landscape {
  height: 80vh;
  display: flex;
  max-height: 700px;
  justify-content: center;
}
</style>
<style>
.modal-open {
  overflow: hidden;
  height: 100vh;
  height: -webkit-fill-available;
  position: fixed;
  left: 0;
  right: 0;
}
.template-status {
  background-color: #b4c7e7;
  border-radius: 5px;
  color: #fff;
  padding: 5px;
  font-size: 10px;
  width: 42px;
}

/* @media screen and(max-width: 768px) { */
/* @media screen and(max-width: 768px) {
  
} */
@media screen and (max-height: 480px) {
  .info-template-mobile {
    padding-left: 45px !important;
  }
}
@media screen and (max-width: 568px) {
  @media screen and (max-height: 320px) {
    .modal-btn-next {
      right: -15px !important;
    }
    .modal-btn-prev {
      left: -15px !important;
    }
    .btn-txt-ttl {
      font-size: 11px;
    }
  }
}

.mobile-mainimg-portrait {
  height: auto !important;
  width: auto !important;
}
</style>
